import { useMemo } from 'react';
import { useFieldArray } from 'react-hook-form';

import { FieldArrayProvider as FieldArrayContextProvider } from './context/fieldArrayContext';

import type { FieldArrayContextState } from './context/fieldArrayContext';
import type { FC, ReactElement } from 'react';
import type { ControllerProps } from 'react-hook-form';

export interface FieldControlProps {
  children: ReactElement | ReactElement[];
  name: ControllerProps['name'];
}

export const FieldArrayProvider: FC<FieldControlProps> = ({
  children: child,
  name,
}) => {
  const {
    fields,
    append,
    prepend,
    remove,
    swap,
    move,
    insert,
    update,
    replace,
  } = useFieldArray( { name } );

  const value: FieldArrayContextState = useMemo( () => ({
    fields,
    append,
    prepend,
    remove,
    swap,
    move,
    insert,
    update,
    replace,
    name,
  }), [
    fields,
    append,
    prepend,
    remove,
    swap,
    move,
    insert,
    update,
    replace,
    name,
  ] );

  return (
    <FieldArrayContextProvider value={value}>
      {child}
    </FieldArrayContextProvider>
  );
};
